import { render, staticRenderFns } from "./starColorful.vue?vue&type=template&id=53f4e677"
import script from "./starColorful.vue?vue&type=script&lang=js"
export * from "./starColorful.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports